import type { ReactElement } from 'react';
import { useCategoriesQuery } from '@/entities/category';

interface CategorySelectProps {
  readonly value: string | null;
  readonly onChange: (categoryId: string | null) => void;
  readonly label: string;
  readonly disabled?: boolean;
}

/** 템플릿을 지정할 카테고리 — 대분류에 두면 소분류 전체가 상속하고, 소분류 템플릿이 우선한다. */
export const CategorySelect = ({
  value,
  onChange,
  label,
  disabled = false,
}: CategorySelectProps): ReactElement => {
  const categories = useCategoriesQuery();
  return (
    <select
      aria-label={label}
      className="h-9 rounded-md border bg-background px-2 text-sm"
      value={value ?? ''}
      disabled={disabled || categories.isPending}
      onChange={(event) => onChange(event.target.value === '' ? null : event.target.value)}
    >
      <option value="">카테고리 지정 안 함</option>
      {(categories.data ?? []).map((root) => (
        <optgroup key={root.id} label={root.name}>
          <option value={root.id}>{root.name} (대분류 전체)</option>
          {root.children.map((child) => (
            <option key={child.id} value={child.id}>
              {root.name} &gt; {child.name}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
};
